export default {
  data() {
    return{
    }
  },
  methods:{
    validateId(rule, value, callback) {
      var re  = /^[A-Za-z0-9]*$/
      if(re.test(value) && value.length >= 6 && this.ruleForm.mb_id_overlap) {
        callback()
      }else if(value.length == 0) {
        callback(new Error('아이디를 입력해주세요.'))
      }else if(!re.test(value) || value.length < 6) {
        callback(new Error('아이디는 6자 이상 영문, 숫자만 입력가능합니다.'))
      }else {
        callback(new Error('아이디 중복확인을 해주세요.'))
      }
    },
    validateEmail(rule, value, callback) {
      var re = /^[a-zA-Z0-9+-\_.]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
      if(!re.test(value)) {
        callback(new Error('이메일 형식에 맞게 입력해주세요.'));
      }else{
        callback();
      }
    },
    validatePass(rule, value, callback){
      var re = /^[A-Za-z0-9]*$/;
      var check1 = /^(?=.*[a-zA-Z])(?=.*[0-9]).{6,12}$/.test(value);   //영문,숫자
      var check2 = /^(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,16}$/.test(value);  //영문,특수문자
      var check3 = /^(?=.*[^a-zA-Z0-9])(?=.*[0-9]).{8,16}$/.test(value);  //특수문자, 숫자
      if(value.length > 0 && value.length < 6){
        callback(new Error('비밀번호는 최소 6자 이상입니다.'));
      }else if(value.length > 12) {
        callback(new Error('비밀번호는 최대 12자 입니다.'));
      }else if(!re.test(value)) {
        callback(new Error('비밀번호는 영문과 숫자만 입력가능합니다.'))
      }else{
        callback();
      }
    },
    validatePass2(rule, value, callback){
      if (value !== this.ruleForm.mb_password) {
        callback(new Error('비밀번호가 일치하지않습니다.'));
      } else {
        callback();
      }
    },
    validateNumber(rule, value, callback) {
      var re = /^[0-9]*$/;
      value += '';
      if(!re.test(value)) {
        callback(new Error('숫자만 입력 가능합니다.'));
      }else{
        callback();
      }
    },
    validatePhone(rule, value, callback){
      if (value === '') {
        callback(new Error('필수 입력사항입니다.'));
      } else {
        var re = /^[0-9]*$/;
        let val_f = value.slice(0, 1)
        if(re.test(value) && value.length > 9 && value.length < 12 && val_f === '0' ){
          callback();
        }else{
          callback(new Error('10~11자리 숫자만 입력가능.'));
        }
      }
    },
    validateHp(rule, value, callback) {
      let phone1 = this.ruleForm.mb_hp1 + '';
      let phone2 = this.ruleForm.mb_hp2 + '';
      let phone3 = this.ruleForm.mb_hp3 + '';
      this.ruleForm.mb_hp = `${phone1}-${phone2}-${phone3}`;
      if(phone1.length === 0 && phone2.length === 0 && phone3.length === 0) {
        callback(new Error('회사 전화번호를 입력해주세요.'))
      }else if(phone1.length < 1 || phone1.length > 3) {
        callback(new Error('회사 전화번호의 시작값을 1자 이상 3자이하 입니다.'))
      }else if(phone2.length < 1 || phone2.length > 4) {
        callback(new Error('회사 전화번호의 중간값은 1자 이상 4자 이하입니다.'))
      }else if(phone3.length < 1 || phone3.length > 4) {
        callback(new Error('회사 전화번호의 끝값을 1자 이상 4자 이하 입니다.'))
      }else{
        callback();
      }
    },
    validateHpCor(rule, value, callback) {
      let phone1 = this.ruleForm.mb_hp1 + '';
      let phone2 = this.ruleForm.mb_hp2 + '';
      let phone3 = this.ruleForm.mb_hp3 + '';
      if(phone1.length === 0 && phone2.length === 0 && phone3.length === 0) {
        this.ruleForm.mb_hp = '';
        callback()
      }else{
        this.ruleForm.mb_hp = `${phone1}-${phone2}-${phone3}`;
        if(phone1.length < 1 || phone1.length > 3) {
          callback(new Error('회사 전화번호의 시작값을 1자 이상 3자이하 입니다.'))
        }else if(phone2.length < 1 || phone2.length > 4) {
          callback(new Error('회사 전화번호의 중간값은 1자 이상 4자 이하입니다.'))
        }else if(phone3.length < 1 || phone3.length > 4) {
          callback(new Error('회사 전화번호의 끝값을 1자 이상 4자 이하 입니다.'))
        }else{
          callback();
        }
      }
    },
    validateFax(rule, value, callback) {
      let phone1 = this.ruleForm.mb_fax1 + '';
      let phone2 = this.ruleForm.mb_fax2 + '';
      let phone3 = this.ruleForm.mb_fax3 + '';
      this.ruleForm.mb_fax = `${phone1}-${phone2}-${phone3}`;
      if(phone1.length === 0 && phone2.length === 0 && phone3.length === 0) {
        callback(new Error('회사 팩스번호를 입력해주세요.'))
      }else if(phone1.length < 1 || phone1.length > 3) {
        callback(new Error('회사 팩스번호의 시작값을 1자 이상 3자이하 입니다.'))
      }else if(phone2.length < 1 || phone2.length > 4) {
        callback(new Error('회사 팩스번호의 중간값은 1자 이상 4자 이하입니다.'))
      }else if(phone3.length < 1 || phone3.length > 4) {
        callback(new Error('회사 팩스번호의 끝값을 1자 이상 4자 이하 입니다.'))
      }else{
        callback();
      }
    },

    validateFaxCor(rule, value, callback) {
      let phone1 = this.ruleForm.mb_fax1 + '';
      let phone2 = this.ruleForm.mb_fax2 + '';
      let phone3 = this.ruleForm.mb_fax3 + '';
      if(phone1.length === 0 && phone2.length === 0 && phone3.length === 0) {
        callback()
        this.ruleForm.mb_fax = ``;
      }else{
        this.ruleForm.mb_fax = `${phone1}-${phone2}-${phone3}`;
        if(phone1.length < 1 || phone1.length > 3) {
          callback(new Error('회사 팩스번호의 시작값을 1자 이상 3자이하 입니다.'))
        }else if(phone2.length < 1 || phone2.length > 4) {
          callback(new Error('회사 팩스번호의 중간값은 1자 이상 4자 이하입니다.'))
        }else if(phone3.length < 1 || phone3.length > 4) {
          callback(new Error('회사 팩스번호의 끝값을 1자 이상 4자 이하 입니다.'))
        }else{
          callback();
        }
      }
    },
    validateUrl(rule, value, callback) {
      // var re = /^(((http(s?))\:\/\/)?)([0-9a-zA-Z\-]+\.)+[a-zA-Z]{2,6}(\:[0-9]+)?(\/\S*)?$/;
      var re = /^(((http(s?))\:\/\/)?)([0-9a-zA-Z\-]+\.)+[a-zA-Z]{2,6}(\:[0-9]+)?(\/\S*)?$/;
      if(!re.test(value)) {
        callback(new Error('홈페이지 형식을 입력해주세요.'))
      }else{
        callback();
      }
    },
    validateName(rule, value, callback) {
      var re = /^[가-힣\\-]*$/;
      if(!re.test(value)) {
        callback(new Error('한글만 입력 가능합니다.'))
      }else{
        callback();
      }
    },
    validateManagerHp(rule, value, callback) {
      let phone1 = this.ruleForm.mb_manager_hp1 + '';
      let phone2 = this.ruleForm.mb_manager_hp2 + '';
      let phone3 = this.ruleForm.mb_manager_hp3 + '';
      this.ruleForm.mb_manager_hp = `${phone1}-${phone2}-${phone3}`;
      if(phone1.length === 0 && phone2.length === 0 && phone3.length === 0) {
        callback(new Error('담당자 연락처를 입력해주세요.'))
      }else if(phone1.length < 1 || phone1.length > 3) {
        callback(new Error('담당자 연락처의 시작값을 1자 이상 3자이하 입니다.'))
      }else if(phone2.length < 1 || phone2.length > 4) {
        callback(new Error('담당자 연락처의 중간값은 1자 이상 4자 이하입니다.'))
      }else if(phone3.length < 1 || phone3.length > 4) {
        callback(new Error('담당자 연락처의 끝값을 1자 이상 4자 이하 입니다.'))
      }else{
        callback();
      }
    },
    validateManagerHpCor(rule, value, callback) {
      let phone1 = this.ruleForm.mb_manager_hp1 + '';
      let phone2 = this.ruleForm.mb_manager_hp2 + '';
      let phone3 = this.ruleForm.mb_manager_hp3 + '';
      if(phone1.length === 0 && phone2.length === 0 && phone3.length === 0) {
        this.ruleForm.mb_manager_hp = ``;
        callback();
      }else{
        this.ruleForm.mb_manager_hp = `${phone1}-${phone2}-${phone3}`;
        if(phone1.length < 1 || phone1.length > 3) {
          callback(new Error('담당자 연락처의 시작값을 1자 이상 3자이하 입니다.'))
        }else if(phone2.length < 1 || phone2.length > 4) {
          callback(new Error('담당자 연락처의 중간값은 1자 이상 4자 이하입니다.'))
        }else if(phone3.length < 1 || phone3.length > 4) {
          callback(new Error('담당자 연락처의 끝값을 1자 이상 4자 이하 입니다.'))
        }else{
          callback();
        }
      }
    },
    validateManagerMail(rule, value, callback) {
      var re = /^((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/
      this.ruleForm.mb_manager_email = `${this.ruleForm.mb_manager_email_id}@${this.ruleForm.mb_manager_email_domail}`;
      if(this.ruleForm.mb_manager_email_domail.length === 0) {
        callback(new Error('담당자의 이메일을 입력해주세요.'))
      }else if(!re.test(this.ruleForm.mb_manager_email_domail)) {
        callback(new Error('이메일 형식을 다시 입력해주세요.'))
      }else{
        callback();
      }
    },
    validateManagerMailCor(rule, value, callback) {
      var re = /^((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/
      if(this.ruleForm.mb_manager_email_id.length === 0 && this.ruleForm.mb_manager_email_domail.length === 0) {
        callback()
      }else{
        this.ruleForm.mb_manager_email = `${this.ruleForm.mb_manager_email_id}@${this.ruleForm.mb_manager_email_domail}`;
        if(this.ruleForm.mb_manager_email_domail.length === 0) {
          callback(new Error('담당자의 이메일을 입력해주세요.'))
        }else if(!re.test(this.ruleForm.mb_manager_email_domail)) {
          callback(new Error('이메일 형식을 다시 입력해주세요.'))
        }else{
          callback();
        }
      }
    },
    validateManagerMailMypage(rule, value, callback) {
      value += this.ruleFormManager.mail2;
      var re = /^((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/
      if(value === 0) {
        callback(new Error('담당자의 이메일을 입력해주세요.'))
      }else if(!re.test(value)) {
        callback(new Error('이메일 형식을 다시 입력해주세요.'))
      }else{
        callback();
      }
    },
    validateAccount(rule, value, callback) {
      if(this.ruleForm.b_idx === '') {
        callback(new Error('은행을 선택해주세요.'))
      }else{
        callback();
      }
    },
    validatePhoneEmpty(rule, value, callback) {
      var re = /^[0-9]*$/;
      if(re.test(value) && value.length > 9 && value.length < 12){
        callback();
      }else{
        callback(new Error('10~11자리 숫자만 입력가능.'));
      }
    },

    validateRecvDate(rule, value, callback) {
      if(this.$moment().diff(value) < 0 || !value) {
        callback();
      }else{
        callback(new Error('예약전송은 현재시간 이후에 가능합니다.'));
      }
    },

    validatePointInput(rule, value, callback) {
      if(value > 0) {
        callback();
      }else{
        callback(new Error('1 이상의 값만 가능합니다.'));
      }
    },
    validateOnlyInteger(rule, value, callback) {
      if(value > 0 || !isNaN(value)) {
        callback();
      }else{
        callback(new Error('1 이상의 값만 가능합니다.'));
      }
    },
    validateOverZero(rule, value, callback) {
      if(value >= 0 && !isNaN(value)) {
        callback();
      }else{
        callback(new Error('1 이상의 값만 가능합니다.'));
      }
    },
    validateExceptHtml(rule, value, callback){
      let content = value.replace(/<(\/p|br|p)([^>]*)>/gi,"");
      if(content.length === 0) {
        callback(new Error(`필수 입력사항입니다.`));
      }else{
        callback();
      }
    },
  }
}
